import IndexedDB from "@/helpers/IndexedDB.js";

export default class User {
	access_token = "";
	created_at = "";
	datarutas_company_id = "";
	email = "";
	expire_token = "";
	identification = "";
	key = "";
	lastname = "";
	name = "";
	serviroutes_company_id = "";
	serviroutes_company_name = "";
	serviroutes_id = "";
	serviroutes_oauth_client_name = "";
	serviroutes_permissions = "";
	serviroutes_role_id = "";
	serviroutes_role_name = "";
	serviroutes_status = "";
	token_type = "";
	uid = "";
	updated_at = "";
	username = "";

	constructor(data = null) {
		if (data) {
			this.access_token = data["access_token"];
			this.created_at = data["created_at"];
			this.datarutas_company_id = data["datarutas_company_id"];
			this.email = data["email"];
			this.expire_token = data["expire_token"];
			this.identification = data["identification"];
			this.key = data["key"];
			this.lastname = data["lastname"];
			this.name = data["name"];
			this.serviroutes_company_id = data["serviroutes_company_id"];
			this.serviroutes_company_name = data["serviroutes_company_name"];
			this.serviroutes_id = data["serviroutes_id"];
			this.serviroutes_oauth_client_name = data["serviroutes_oauth_client_name"];
			this.serviroutes_permissions = data["serviroutes_permissions"];
			this.serviroutes_role_id = data["serviroutes_role_id"];
			this.serviroutes_role_name = data["serviroutes_role_name"];
			this.serviroutes_status = data["serviroutes_status"];
			this.token_type = data["token_type"];
			this.uid = data["uid"];
			this.updated_at = data["updated_at"];
			this.username = data["username"];
			this.saveUid(this.uid);
			localStorage.setItem("userInfo", JSON.stringify(data));
		}
	}

	saveUid(uid) {
		localStorage.setItem("open-route-uid", uid);
	}

	isLogin() {
		return localStorage.getItem("open-route-uid") ? true : false;
	}
	async getToken() {
		if (this.isLogin()) {
			const uid = localStorage.getItem("open-route-uid");
			const query = {uid};
			const result = await IndexedDB.where_("users", query, {query: "first"});
			localStorage.setItem("accessToken", result.access_token);
			return result.access_token;
		} else {
			return null;
		}
	}

	async getUser() {
		const uid = localStorage.getItem("open-route-uid");
		const query = {uid};
		const result = await IndexedDB.where_("users", query, {
			query: "first",
		});
		return result;
	}

	async clearUser() {
		localStorage.removeItem("open-route-uid");
		localStorage.removeItem("userInfo");
		await IndexedDB.truncate("users", null);
	}

	async deleteUserIndexed() {
		const uid = localStorage.getItem("open-route-uid");
		const query = {uid};
		const result = await IndexedDB.deleteKey("users", query.uid);
		return result;
	}
}
